
import { useQuery } from '@tanstack/react-query';
import secureLocalStorage from 'react-secure-storage';

import { getDasFundSummary } from '../../../services/das.service';
import { extractErrorMessage } from '../../extractErrorMessage';
import { notifyUser } from '../../../util/util';

const notifiedErrors = new Set();

// Helper function to notify only once for the same error
const notifyOnce = (type, message, title = "") => {
  if (!notifiedErrors.has(message)) {
    notifiedErrors.add(message);
    notifyUser(type, message, title);
  }
};

// Fetches the DAS fund summary (total schemes + total pensions) from
// /v1/das/fund-summary using React Query
export function useDasFundSummary() {
  return useQuery({
    queryKey: ['das-fund-summary'],
    queryFn: async () => {
      try {
        const result = await getDasFundSummary();
        if (!result || !result.success) {
          throw new Error(result?.message || 'Failed to fetch DAS fund summary');
        }
        return result;
      } catch (error) {
        const errorMessage = extractErrorMessage(error, 'Failed to fetch DAS fund summary');
        notifyOnce("error", errorMessage, "Error");
        throw new Error(errorMessage);
      }
    },
    enabled: !!secureLocalStorage.getItem('token'),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
}
